import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import { getImageFromImageObject } from 'components/Image/utils';
import classNames from 'classnames';
import format from 'date-fns/format';
/* import makeRequest from '../../../../utils/makeRequest'; */
import s from './MovieReviewCard.scss';

class MovieReviewCard extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  static getDuration(minutes) {
    if (minutes < 60) {
      return `${minutes} mins`;
    }
    if (minutes < 120) {
      return `1 hr ${minutes - 60} mins`;
    }
    return `${parseInt(minutes / 60, 10)} hrs ${minutes % 60} mins`;
  }

  render() {
    const { data = {}, isLead } = this.props;
    const {
      wu,
      hl,
      movieGenre = '',
      image,
      rating,
      otherLanguages = '',
      movieCast,
      releaseDate,
      movieDuration,
      certificate,
    } = data;
    const languages = otherLanguages.split(',').join(', ');
    const genre = movieGenre.split(',').join(', ');
    const imageMsid = getImageFromImageObject(image);
    const containerClassname = classNames({
      [s.moviereview]: true,
      [s.leadcard]: isLead,
    });
    return (
      <Link className={containerClassname} to={wu}>
        {isLead && (
          <div className={s.backthumb}>
            <Image
              src={`https://static.toiimg.com/photo/${imageMsid}.cms`}
              alt=""
            />
          </div>
        )}
        <div className={s.movieinfo}>
          <div className={s.moviedetails}>
            {isLead && <div className={s.heading}>Movie Review</div>}
            <div className={s.name}>{hl}</div>
            {!isLead && (
              <React.Fragment>
                <div className={s.infotxt}>{movieCast}</div>
                <div className={s.rating}>
                  <b>Critic Rating</b>
                  <span className={s.star}>{rating}</span>
                </div>
                <div className={s.infotxt}>
                  {languages} <br />
                  {genre} | {certificate}
                </div>
                <div className={s.bottomText}>
                  {format(releaseDate, 'DD MMM YYYY')}
                  {movieDuration &&
                    ` | ${MovieReviewCard.getDuration(movieDuration)}`}
                </div>
              </React.Fragment>
            )}
            {isLead && (
              <React.Fragment>
                <div className={s.infotxt}>
                  {languages} <br />
                  {genre}
                </div>
                <div className={s.rating}>
                  <b>Critic Rating</b>
                  <span className={s.star}>{rating}</span>
                </div>
              </React.Fragment>
            )}
          </div>
          <div className={s.poster}>
            <Image
              src={`https://timesofindia.indiatimes.com/photo/${imageMsid}.cms`}
              alt=""
              className={s.content}
            />
          </div>
        </div>
      </Link>
    );
  }
}
MovieReviewCard.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isLead: PropTypes.bool,
};
MovieReviewCard.defaultProps = {
  isLead: undefined,
};

export default MovieReviewCard;
